var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboardAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.222C0 3.687 3.588 0 8 0s8 3.687 8 8.222A8.35 8.35 0 0114.508 13l-.781-.634A7.321 7.321 0 0015 8.222c0-3.979-3.128-7.194-7-7.194S1 4.243 1 8.222a7.32 7.32 0 001.273 4.144l-.78.634A8.351 8.351 0 010 8.222zM6.914 9.38l4.211-4.923-2.039 6.207a1.237 1.237 0 01-1.71.474 1.31 1.31 0 01-.462-1.758z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardAlt);
export default __webpack_public_path__ + "static/media/icon-dashboard-alt.3b53f941c374ba2f199d020ba1b8c57f.svg";
export { ForwardRef as ReactComponent };